import React from 'react'

const RightArrowIcon = () => {
  return (
    <svg
      width="7"
      height="12"
      viewBox="0 0 7 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.699804 11.3C0.516471 11.1167 0.424805 10.8834 0.424805 10.6C0.424805 10.3167 0.516471 10.0834 0.699804 9.90005L4.5998 6.00005L0.699804 2.10005C0.516471 1.91672 0.424805 1.68338 0.424805 1.40005C0.424805 1.11672 0.516471 0.883382 0.699804 0.700048C0.883138 0.516715 1.11647 0.425049 1.3998 0.425049C1.68314 0.425049 1.91647 0.516715 2.0998 0.700048L6.6998 5.30005C6.7998 5.40005 6.8708 5.50838 6.9128 5.62505C6.95414 5.74172 6.9748 5.86672 6.9748 6.00005C6.9748 6.13338 6.95414 6.25838 6.9128 6.37505C6.8708 6.49172 6.7998 6.60005 6.6998 6.70005L2.0998 11.3C1.91647 11.4834 1.68314 11.575 1.3998 11.575C1.11647 11.575 0.883138 11.4834 0.699804 11.3Z"
        fill="#CCCFD6"
      />
    </svg>
  )
}

export default RightArrowIcon
